<template>
    <div>
        <div class="container-fluid" style="background-color: white">
            <div class="text-right">
                <a @click="closeAdvancePaymentDetails">
                    <icon name="times" style="width: 50px"></icon>
                </a>
            </div>

            <h3 class="text-center">บันทึกการคืนเงิน</h3>
            <div class="mt-3 text-center">
                <label>รหัสพนักงาน {{ form.employee.employee_no }}</label>&nbsp;&nbsp;&nbsp;
                <label>ชื่อ-นามสกุล {{ form.employee.name }}</label>
                <br>

                <label>
                    ยอดเงินที่เบิก
                    <span class="text-bold">{{ form.total_advance_payment | currency }} </span>
                    บาท
                </label>&nbsp;&nbsp;
                <label>
                    ยอดเงินคืนสะสม
                    <span class="text-bold">{{ form.sum_amount_return_per_month | currency }} </span>
                    บาท
                </label>&nbsp;&nbsp;
                <label>
                    คงเหลือ
                    <span class="text-bold">{{ form.balance_advance_payment | currency }} </span>
                    บาท
                </label>&nbsp;&nbsp;
                <br>

                <label>
                    <span class="text-bold">วิธีการชำระ</span>
                    หักจากเงินเดือน
                    <template v-if="form.advance_payment_status== 1">
                        เดือนละ
                    </template>
                    <template v-else>
                        ครึ่งเดือนเดือนละ
                    </template>
                    {{ form.amount_return_per_month | currency }} บาท
                </label>&nbsp;

            </div>

            <div class="mt-3 table-responsive">
                <table style="text-align: center" class="table table-bordered">
                    <thead>
                    <tr>
                        <th scope="col">วัน/เดือน/ปี ที่จ่าย</th>
                        <th scope="col">จำนวน</th>
                        <th scope="col">ผู้ชำระ</th>
                        <th scope="col">ผู้รับเงิน</th>
                        <th scope="col">ปิดยอด</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in AdvancePaymentDetailsList">
                        <td>{{ data.date | moment('DD/MM/YYYY') }}</td>
                        <td>
                            <template v-if="data.amount_return_advance_payment == 0">
                                -
                            </template>
                            <template v-else>
                                + {{ data.amount_return_advance_payment | currency }}
                            </template>
                        </td>
                        <td>{{ form.employee ? form.employee.name : '' }}</td>
                        <td>{{ form.recorder }}</td>
                        <td>
                            <button v-if="data.amount_return_advance_payment == 0" class="btn btn-danger"
                                    @click="showDialogModal(data.id)">
                                ปิดยอด
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="AdvancePaymentDetailsList.length > 0">
                <vue-pagination :pagination="dataPaginate"
                                @paginate="getAdvancePaymentListDetails(dataPaginate.current_page)">
                </vue-pagination>
            </div>
        </div>
        <!--        <pre class="alert-success">{{AdvancePaymentDetailsList}}</pre>-->
        <!--        <pre class="alert-primary">{{form}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex"
import VuePagination from "../../../Pagination";
import Loading from "../../../Utility/Loading";
import DeleteConfirmModal from "../../../Utility/DeleteConfirmModal";

export default {
    name: "advance-payment-form",
    data() {
        return {
            delete_id: "",
        }
    },
    created() {

    },
    components: {
        DeleteConfirmModal,
        Loading,
        VuePagination,
    },
    computed: {
        ...mapState({
            form: (state) => {
                return state.AdvancePayment.form;
            },
            AdvancePaymentDetailsList: (state) => {
                return state.AdvancePaymentDetails.AdvancePaymentDetailsList;
            },
            dataPaginate: state => {
                return state.AdvancePaymentDetails.dataPaginate;
            },

        })
    },
    methods: {
        getAdvancePaymentListDetails(page) {
            //paginate search
            if (this.event_submit) {
                //console.log('search')
                // if(this.search.rental_fee){
                //     this.search.rental_fee_id = this.search.rental_fee.id
                // }
                // else{
                //     this.search.rental_fee_id = ""
                // }
                // let data={
                //     page : page,
                //     rental_fee_id : this.search.rental_fee_id
                // };
                // this.$store.dispatch('RentalFee/search',data)
            }
            //paginate get data
            else {
                let data = {
                    page: page,
                    id: this.form.id
                };
                this.$store.dispatch('AdvancePaymentDetails/showAdvancePaymentDetailsById', data)
            }
        },
        closeAdvancePaymentDetails() {
            this.$emit("submit", 0)
        },
        DeleteConfirmModal(id) {
            //console.log(id);
        },
        showDialogModal(id) {
            if (confirm('คุณต้องการลบรายการนี้ ?')) {
                //console.log(id);
                this.$store.dispatch('AdvancePaymentDetails/deleteAdvancePaymentDetails', id).then(() => {
                    this.$store.dispatch("AdvancePayment/showAdvancePaymentById", this.form.id).then(() => {
                        this.getAdvancePaymentListDetails(1);
                    });
                });
            } else {
                //console.log('false');
            }
        }
    }
}
</script>

<style scoped>
.text-bold {
    font-weight: bold;
}

</style>
